export const catalog = {
  HERO_TITLE: ', o marketplace de soluções para o seu negócio',
  HERO_TITLE_BRAND: 'Sebraeplace',
  HERO_SUBTITLE:
    'As melhores soluções, o melhor preço.\nContrate de forma fácil e segura com a curadoria do Sebrae',
  MODALITY_LABEL: 'MODALIDADE',
  MODALITY_ALL: 'Todas',
  MODALITY_SEBRAETEC: 'Sebraetec',
  MODALITY_CONSULTORIA: 'Consultoria',
  MODALITY_SAAS: 'Soluções inteligentes',
  MODALITY_CURSO: 'Curso online',
  SORT_LABEL: 'ORDENAR POR',
  SORT_RELEVANT: 'Mais relevantes',
  SORT_PRICE_ASC: 'Menor preço',
  SORT_PRICE_DESC: 'Maior preço',
  SORT_RATED: 'Melhor avaliados',
  FILTER_TITLE: 'FILTROS',
  FILTERS_TITLE: 'Filtros',
  FILTER_CLEAR: 'Limpar filtros',
  FILTER_SEARCH_PLACEHOLDER: 'Pesquise por Nome ou Código',
  FILTER_SEE_MORE: 'Ver mais ({{qty}})',
  FILTER_SEE_LESS: 'Ver menos',
  FILTER_PRICE: 'PREÇO',
  FILTER_SEGMENT: 'SEGMENTO',
  SEE_ALL: 'Ver todos',
  CATALOG_HEADING: 'Catálogo Sebraeplace',
  SECTION_SEBRAETEC_TITLE: 'Sebraetec',
  SECTION_SEBRAETEC_SUB:
    'Encontre serviços altamente qualificados de forma prática, rápida e segura',
  SECTION_CONSULTORIA_TITLE: 'Consultoria',
  SECTION_CONSULTORIA_SUB:
    'Encontre serviços altamente qualificados de forma prática, rápida e segura',
  SECTION_SOLUCAO_TITLE: 'Soluções inteligentes',
  SECTION_SOLUCAO_SUB:
    'Soluções para ampliar e facilitar a rotina da sua empresa',
  SECTION_CURSO_TITLE: 'Curso online',
  SECTION_CURSO_SUB:
    'Encontre serviços altamente qualificados de forma prática, rápida e segura',
  NAV_PREV: 'Anterior',
  NAV_NEXT: 'Próximo',
  BREADCRUMB_CATALOG: 'Catálogo',
  RELATED_HEADING: 'Você também pode se interessar por isso',
  GRID_LOAD_MORE: 'Ver mais resultados',
  SECTION_EMPTY: 'Nenhum resultado encontrado',
  HERO_SEBRAETEC_TITLE: 'Sebraetec, inovação para resultados reais',
  HERO_SEBRAETEC_HL: 'Sebraetec',
  HERO_SEBRAETEC_SUB:
    'Leve tecnologia e competitividade para sua empresa com soluções sob medida.',
  HERO_CONSULTORIA_TITLE:
    'Consultoria, estratégias\nsob medida para seu negócio',
  HERO_CONSULTORIA_HL: 'Consultoria',
  HERO_CONSULTORIA_SUB:
    'Conte com especialistas para orientar decisões e acelerar o crescimento do seu negócio com diagnósticos precisos.',
  HERO_SAAS_TITLE: 'Soluções Inteligentes, inove, otimize e cresça',
  HERO_SAAS_HL: 'Soluções Inteligentes',
  HERO_SAAS_SUB:
    'Tome decisões mais inteligentes com apoio estratégico e ferramentas digitais.',
  HERO_CURSO_TITLE: 'Curso online, capacitação onde e quando você quiser',
  HERO_CURSO_HL: 'Curso online',
  HERO_CURSO_SUB:
    'Conhecimento que gera resultado: cursos online pensados para quem faz acontecer.',
  FILTER_AREA: 'Área',
  FILTER_ESPECIALIDADES: 'Especialidades',
  FILTER_TEMAS: 'Temas',
  FILTER_SUBTEMAS: 'Subtemas',
  FILTER_CATEGORIAS: 'Categorias',
  FILTER_SUBCATEGORIAS: 'Subcategorias',
  FILTER_PORTES: 'Portes'
};
